import React, { useEffect, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";

import {
  createCreateOrderOfBilling,
  updateCreateOrderOfBilling,
} from "../../graphql/mutations";
import { listCreateOrderOfBillings } from "../../graphql/queries";

import fetchItemsNextToken from "../../function/fetchItemsNextTokenZau";
import {
  Card,
  Row,
  Col,
  Input,
  Select,
  DatePicker,
  Modal,
  Button,
  notification,
  Table,
  Tag,
  Statistic,
  Collapse,
  Descriptions,
  Alert,
  Checkbox,
} from "antd";
import { DeleteOutlined, PlusOutlined, UserOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import Dropdown from "react-bootstrap/Dropdown";
import "../Check Paid/checkop.css";
const { TextArea } = Input;
const { Option } = Select;
const { Panel } = Collapse;

const user = JSON.parse(localStorage.getItem("profile"));
const token = localStorage.getItem("token");

const {
  REACT_APP_CHECK_OP,
} = process.env;

const COEForm = (props) => {
  const [occupancy, setOccupancy] = useState("0");
  const [values, setValues] = useState({
    ceNo: "",
    applicationNo: "",
    applicationCategory: "",
    projectActivity: "",
    evaluation_facts_extended: "",
    lotNo: "",
    blkNo: "",
    address: "",
    street: "",
    barangay: "",
    district: "",
    owner: "",
    zoneClassification: "",
    occupancy: "",
    lotArea: "",
    floorArea: "",
    noOfUnit: "",
    tctNo: "",
    evaluationOfFacts: "",
    postalAddress: "",
    counselResolutionNo: "",
    oldOp: "",
  });
  const [checkArray, setCheckedArray] = useState([
    {
      paymentitem: "",
      fees: "",
      AccountName: "",
      Accountcode: "",
      OfficeCode: "",
      surcharge: "",
      penalties: "",
      total: "",
    },
  ]);
  const [listPayitem, setListPayitem] = useState([
    "Zoning - Application (Filling) Fee",
    "Zoning - Certification",
    "Zoning - Commercial",
    "Zoning - Fee",
    "Zoning - Industrial",
    "Zoning - Motion for Reconsideration",
    "Zoning - Others",
    "Zoning - Processing Fee",
    "Zoning - Residential",
    "Zoning - Security Seal",
    "Zoning - Surcharge",
    "Zoning - Verification Fee",
    "Zoning Fees Subdivision",
    "BP 220 Plan Approval",
    "Annual Inspection Fees - CPDO",
    "Locational Clearance of Business",
    "PD 957",
    "Processing Fee: Preliminary Plans",
    "Vertical Component",
  ]);
  const [counselResolutionDate, setCancelResolutionDate] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [grandTotal, setGrandTotal] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [statusEvent, setStatusEvent] = useState(1);
  const [applicationId, setApplicationId] = useState("");
  const [newapplication, setNewApplication] = useState([]);
  const [recommendation, setRecommendation] = useState([]);
  const [approval, setapproval] = useState([]);
  const [payment, setforpayment] = useState([]);
  const [denied, setDenied] = useState([]);
  const [opData, setopData] = useState([]);
  const [viewData, setviewData] = useState(false);
  const [checkifhaspayitem, setCheckIfhaspayitem] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [forRelease, setForRelease] = useState([]);
  const [occupancy2, setOccupancy2] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [isHaveOlderOP, setIsHaveOlderOP] = useState(false);

  useEffect(() => {
    fetchNewApplication(props.ownerId);
    fetchRecommendation(props.ownerId);
    fetchForAppoval(props.ownerId);
    fetchForPayment(props.ownerId);
    fetchDenied(props.ownerId);
    fetchAll(props.ownerId);
    fetchAllRelease(props.ownerId);
  }, []);

  const fetchAll = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: id },
          },
          limit: 1000,
        },
      };

      const result_fetch_all = await fetchItemsNextToken(queryData);
      setSearchData(
        result_fetch_all.sort(
          (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
        )
      );
      setFilterData(
        result_fetch_all.sort(
          (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllRelease = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            isCleared: { ne: true },
            or: [{ status: { eq: "5" } }, { status: { eq: "6" } }],
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: id },
          },
          limit: 1000,
        },
      };

      const result_fetch_release = await fetchItemsNextToken(queryData);
      setForRelease(
        result_fetch_release.sort(
          (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDenied = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            isCleared: { ne: true },
            status: { eq: "15" },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: id },
          },
          limit: 1000,
        },
      };

      const result_fetch_denied = await fetchItemsNextToken(queryData);
      setDenied(
        result_fetch_denied.sort(
          (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  const fetchForPayment = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "4" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: id },
          },
          limit: 1000,
        },
      };

      const result_fetch_payment = await fetchItemsNextToken(queryData);
      setforpayment(result_fetch_payment);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchForAppoval = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "3" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: id },
          },
          limit: 1000,
        },
      };

      const result_fetch_approval = await fetchItemsNextToken(queryData);
      setapproval(result_fetch_approval);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchRecommendation = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "2" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: id },
          },
          limit: 1000,
        },
      };

      const result_fetch_recommendation = await fetchItemsNextToken(queryData);
      setRecommendation(result_fetch_recommendation);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchNewApplication = async (id) => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "1" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: id },
          },
          limit: 1000,
        },
      };

      const result_fetch_new_application = await fetchItemsNextToken(queryData);
      setNewApplication(result_fetch_new_application);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewApplication = async () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "1" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const result_new_application = await fetchItemsNextToken(queryData);
      setSearchData(result_new_application);
      filterData(result_new_application);
    } catch (error) {
      console.log(error);
    }
  };

  const handleForRecommendation = async () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "2" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const result_new_recommendation = await fetchItemsNextToken(queryData);
      setSearchData(result_new_recommendation);
      filterData(result_new_recommendation);
    } catch (error) {
      console.log(error);
    }
  };

  const handleApproval = async () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "3" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const result_new_approval = await fetchItemsNextToken(queryData);
      setSearchData(result_new_approval);
      filterData(result_new_approval);
    } catch (error) {
      console.log(error);
    }
  };

  const handleforpayment = async () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "4" },
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const result_new_for_payment = await fetchItemsNextToken(queryData);
      setSearchData(result_new_for_payment);
      filterData(result_new_for_payment);
    } catch (error) {
      console.log(error);
    }
  };

  const handleforRelease = async () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            or: [{ status: { eq: "5" } }, { status: { eq: "6" } }],
            isCleared: { ne: true },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const result_new_release = await fetchItemsNextToken(queryData);
      setSearchData(result_new_release);
      filterData(result_new_release);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDenied = async () => {
    try {
      const queryData = {
        query: listCreateOrderOfBillings,
        variables: {
          filter: {
            isDeleted: { ne: "1" },
            status: { eq: "15" },
            typeofapplication: { eq: "COE" },
            ownedBy: { eq: props.ownerId },
          },
          limit: 1000,
        },
      };

      const result_new_denied = await fetchItemsNextToken(queryData);
      setSearchData(result_new_denied);
      filterData(result_new_denied);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const handleDateChange = (date) => {
    setCancelResolutionDate(date);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setValues({
      applicationNo: "",
      address: "",
      projectActivity: "",
      applicationCategory: "",
      owner: "",
      lotArea: "",
      floorArea: "",
      postalAddress: "",
      counselResolutionNo: "",
      counselResolutionDate: "",
      ceNo: "",
    });
    setGrandTotal("");
    setStatusEvent(1);
    setOccupancy("");
    setCancelResolutionDate("");
    setCheckedArray([]);
    setStatusEvent(1);
  };

  const handleshowModal = () => {
    setIsModalVisible(true);
    setStatusEvent(1);
    if (checkArray.length === 1) {
      setCheckedArray([...checkArray]);
    } else if (checkArray.length === 0) {
      setCheckedArray([
        ...checkArray,
        {
          paymentitem: "",
          fees: "",
          surcharge: "",
          penalties: "",
          AccountName: "",
          Accountcode: "",
          OfficeCode: "",
          total: "",
        },
      ]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      const result = API.graphql(
        graphqlOperation(createCreateOrderOfBilling, {
          input: {
            typeofapplication: "COE",
            ceNo: values.ceNo,
            application_no: values.applicationNo,
            application_type: "REGULAR",
            owner: values.owner,
            occupancy: occupancy,
            project_activity: values.projectActivity,
            address: values.address,
            isGovementInstitution: isChecked,
            evaluation_facts_extended: values.evaluation_facts_extended,
            isNoPaymenItem: checkifhaspayitem,
            doesHaveOldOP: isHaveOlderOP,
            opStatus: "0",
            Signature1: "0",
            Signature2: "0",
            status: "1",
            order_payment_no: isHaveOlderOP ? values.oldOp : "0",
            OrNumber: "0",
            OrDate: "0",
            deniedRemarks: JSON.stringify([]),
            deniedDate: JSON.stringify([]),
            Payitem: JSON.stringify(checkArray),
            grandTotal: grandTotal,
            lot_area: values.lotArea,
            floor_area: values.floorArea,
            billing_officer: user.fname + " " + user.mname + " " + user.lname,
            postalAddress: values.postalAddress,
            counselResolutionNo: values.counselResolutionNo,
            counselResolutionDate: counselResolutionDate,
            ownedBy: props.ownerId,
            division: props.division,
          },
        })
      );
      if (result) {
        Swal.fire({
          title: "Save Successful",
          text: "The application was successfully saved.",
          icon: "success",
        }).then(() => {
          setValues({
            ceNo: "",
            applicationNo: "",
            address: "",
            projectActivity: "",
            applicationCategory: "",
            owner: "",
            lotArea: "",
            floorArea: "",
            postalAddress: "",
            counselResolutionNo: "",
            counselResolutionDate: "",
            evaluation_facts_extended: "",
            oldOp:""
          });
          setGrandTotal("");
          setStatusEvent(1);
          setOccupancy("");
          setCancelResolutionDate("");
          setCheckedArray([]);
          setIsModalVisible(false);
          fetchAll(props.ownerId);
          setIsHaveOlderOP(false);
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Fail to save your data",
          icon: "error",
        });
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Fail to save your data",
        icon: "error",
      });
    }
  };

  const handleUpdateShow = (event, data) => {
    event.preventDefault();
    try {
      setIsModalVisible(true);
      setStatusEvent(2);
      setOccupancy(data?.occupancy);
      setOccupancy2(data?.occupancy);
      setApplicationId(data?.id);
      setValues({
        ceNo: data?.ceNo,
        applicationNo: data?.application_no,
        projectActivity: data?.project_activity,
        address: data?.address,
        owner: data?.owner,
        lotArea: data?.lot_area,
        floorArea: data?.floor_area,
        postalAddress: data?.postalAddress,
        counselResolutionNo: data?.counselResolutionNo,
        evaluation_facts_extended: data?.evaluation_facts_extended,
        oldOp: data?.order_payment_no,
      });
      setCancelResolutionDate(data?.counselResolutionDate);
      setIsChecked(data?.isGovementInstitution);
      setCheckIfhaspayitem(data?.isNoPaymenItem);
      setCheckedArray(JSON.parse(data?.Payitem));
      setGrandTotal(data?.grandTotal);
      setIsHaveOlderOP(data?.doesHaveOldOP);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const result = await API.graphql(
        graphqlOperation(updateCreateOrderOfBilling, {
          input: {
            id: applicationId,
            ceNo: values.ceNo,
            Payitem: JSON.stringify(checkArray),
            typeofapplication: "COE",
            application_no: values.applicationNo,
            application_type: "REGULAR",
            isGovementInstitution: isChecked,
            isNoPaymenItem: checkifhaspayitem,
            doesHaveOldOP: isHaveOlderOP,
            owner: values.owner,
            occupancy: occupancy,
            project_activity: values.projectActivity,
            address: values.address,
            grandTotal: grandTotal,
            lot_area: values.lotArea,
            floor_area: values.floorArea,
            postalAddress: values.postalAddress,
            counselResolutionNo: values.counselResolutionNo,
            counselResolutionDate: counselResolutionDate,
            evaluation_facts_extended: values.evaluation_facts_extended,
            order_payment_no: isHaveOlderOP ? values.oldOp : "0",
          },
        })
      );
      if (result) {
        Swal.fire(
          "Data Updated",
          "The data has been successfully updated.",
          "success"
        ).then(() => {
          setValues({
            lcNo: "",
            ceNo: "",
            applicationNo: "",
            applicationCategory: "",
            projectActivity: "",
            evaluation_facts_extended: "",
            lotNo: "",
            blkNo: "",
            address: "",
            street: "",
            barangay: "",
            district: "",
            owner: "",
            zoneClassification: "",
            occupancy: "",
            lotArea: "",
            floorArea: "",
            noOfUnit: "",
            tctNo: "",
            evaluationOfFacts: "",
            postalAddress: "",
            counselResolutionNo: "",
            counselResolutionDate: "",
          });
          setOccupancy("");
          setOccupancy2("");
          setIsModalVisible(false);
          setIsHaveOlderOP(false);
          setGrandTotal("");
          setApplicationId("");
          setCheckedArray([]);
          fetchAll(props.ownerId);
        });
      }
    } catch (error) {}
  };

  /* Forward function */
  const handleForwardOpstatus = async (e, data) => {
    e.preventDefault();
    try {
      Swal.fire({
        title: `Are you sure want to forward ${data.application_no}?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Forward it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          // Swal.fire("Forwarded!", "Your file has been Forwarded.", "success");
          try {
            const fetchResult = await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: data.id,
                  opStatus: "1",
                  status: "2",
                  opStatusDate1: new Date(),
                },
              })
            );
            if (fetchResult) {
              Swal.fire(
                "Forward Successful",
                "The message has been successfully forwarded to the Division Chief.",
                "success"
              ).then(() => {
                window.location.reload();
              });
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handlePrintCOEForm = (id) => {
    let url;
    let title;
    url = "/coe-form-print?id=" + id;
    title = "Locational Form with Certificate of Exception";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const handlePrintOrderOfPayment = (id) => {
    let url;
    let title;
    url = "/orderofpaymentzau-form-print?id=" + id;
    title = "Order of Payment ";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const handleChangeDropdown = (e, index, name) => {
    let total = 0;
    const values = e.target !== undefined ? e.target.value : e;
    const list = [...checkArray];
    list[index][name] = values;

    const a =
      Number(list[index]["fees"]) +
      Number(list[index]["surcharge"]) +
      Number(list[index]["penalties"]);
    list[index]["total"] = a.toFixed(2);
    for (let i = 0; i < list.length; i++) {
      total += Number(list[i]["total"]);
    }

    setGrandTotal(total.toFixed(2));
    setCheckedArray(list);
  };

  const handleRemoveArray = (index) => {
    let total = 0;
    const list = [...checkArray];
    let value = list[index];
    if (!listPayitem.includes(value.paymentitem)) {
      listPayitem.push(value.paymentitem);
    }
    list.splice(index, 1);
    for (let i = 0; i < list.length; i++) {
      total += Number(list[i]["total"]);
    }

    const truncatedAmount = Math.floor(total * 100) / 100;
    const formattedAmount = truncatedAmount.toFixed(2);
    setGrandTotal(formattedAmount);
    setCheckedArray(list);
  };

  const handleAddArray = () => {
    const payItemList = checkArray.map((item) => item.paymentitem);
    for (let i = 0; i < payItemList.length; i++) {
      for (let j = 0; j < listPayitem.length; j++) {
        if (payItemList[i] === listPayitem[j]) {
          const a = listPayitem.indexOf(listPayitem[j]);
          listPayitem.splice(a, 1);
        }
      }
    }

    setListPayitem(listPayitem);
    setCheckedArray([
      ...checkArray,
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
  };

  const viewLocationalClearance = (e, data) => {
    e.preventDefault();
    try {
      setviewData(true);
      setopData(data);
      setCheckedArray(JSON.parse(data?.Payitem));
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseViewData = () => {
    setCheckedArray([]);
    setApplicationId("");
    setviewData(false);
    setValues({
      lcNo: "",
      applicationNo: "",
      address: "",
      projectActivity: "",
      applicationCategory: "",
      lotNo: "",
      blkNo: "",
      evaluation_facts_extended: "",
      street: "",
      barangay: "",
      district: "",
      owner: "",
      zoneClassification: "",
      lotArea: "",
      floorArea: "",
      noOfUnit: "",
      tctNo: "",
      evaluationOfFacts: "",
    });
    setApplicationId("");
    setGrandTotal("");
    setOccupancy("");
    setOccupancy2("");
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    setCheckedArray([
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
    setGrandTotal("");
  };

  const handleChangeNoPayitem = (e) => {
    setCheckIfhaspayitem(e.target.checked);
    setCheckedArray([
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
    setGrandTotal("");
  };

  /* outdated */
  const handleClearApplications = (e, data) => {
    e.preventDefault();
    try {
      Swal.fire({
        title: `Are you sure you want to set this application ${data.application_no} to Cleared? ?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const fetchResult = await API.graphql(
              graphqlOperation(updateCreateOrderOfBilling, {
                input: {
                  id: data.id,
                  isCleared: true,
                  isClearedDate: new Date(),
                },
              })
            );
            if (fetchResult) {
              Swal.fire("Good job!", "Successfully Cleared", "success").then(
                () => {
                  window.location.reload();
                }
              );
            }
          } catch (error) {
            console.log(error);
          }
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  /* outdated */
  const handleMarkAsFinish = async (e, data) => {
    e.preventDefault();
    try {
      const result = await Swal.fire({
        title: `Are you sure you want to set this application ${data.application_no} to Finished?`,
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      });

      if (result.isConfirmed) {
        try {
          const fetchResult = await API.graphql(
            graphqlOperation(updateCreateOrderOfBilling, {
              input: {
                id: data.id,
                status: "6",
                signatureDate2: new Date(),
              },
            })
          );

          if (fetchResult) {
            await Swal.fire({
              title: "Good job!",
              text: "Successfully Cleared",
              icon: "success",
            });

            window.location.reload();
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCheckBillingNumberIfPaid = async (e, data) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: `${data?.application_no}?`,
      text: "Would you like to check if this application is paid and proceed with the update?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Update",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title: "Checking...",
        html: '<div class="custom-loader-container"><div class="custom-loader"></div></div>',
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false, // Remove the "OK" button
      });

      try {
        

        if (data.order_payment_no) {
          const apiSend = {
            search_value: data.order_payment_no,
          };


          const fetchResult = await fetch(REACT_APP_CHECK_OP, {
            headers: { 
              "Content-Type": "application/json",
              "authorization":token
            },
            method: "POST",
            body: JSON.stringify(apiSend),
          });

          const responseData = await fetchResult.json();

          if (responseData.data.totalRecords === 1) {
            const details = responseData.data.details;

            const promises = Object.keys(details).map(async (key) => {
              if (
                details[key].PostFlag === "V" ||
                details[key].PostFlag === "C"
              ) {
                const response = await API.graphql(
                  graphqlOperation(updateCreateOrderOfBilling, {
                    input: {
                      id: data.id,
                      OrNumber: details[key].ORNumber,
                      OrDate: details[key].OrDate,
                      isDeleted: "1",
                    },
                  })
                );

                if (response) {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "OR Number is Cancelled! Please verify the transaction at City Treasurer Office",
                  }).then((result) => {
                    window.location.reload();
                  });
                }
              } else {
                const response = await API.graphql(
                  graphqlOperation(updateCreateOrderOfBilling, {
                    input: {
                      id: data.id,
                      OrNumber: details[key].ORNumber,
                      OrDate: details[key].OrDate,
                      status: "5",
                    },
                  })
                );

                if (response) {
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: response.data.updateCreateOrderOfBilling
                      .order_payment_no,
                  }).then((result) => {
                    window.location.reload();
                  });
                }
              }
            });

            await Promise.all(promises);
          } else {
            Swal.fire("Success!", "Payment is pending.", "warning");
          }
        } else {
          Swal.fire("Success!", "No Order of Payment Number!", "info");
        }
      } catch (error) {
        console.log(error);
        Swal.fire(
          "Error!",
          "An error occurred while checking the billing number.",
          "error"
        );
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      setCheckedArray([]);
      setApplicationId("");
      setviewData(false);
      setValues({
        lcNo: "",
        applicationNo: "",
        address: "",
        projectActivity: "",
        applicationCategory: "",
        lotNo: "",
        blkNo: "",
        evaluation_facts_extended: "",
        street: "",
        barangay: "",
        district: "",
        owner: "",
        zoneClassification: "",
        lotArea: "",
        floorArea: "",
        noOfUnit: "",
        tctNo: "",
        evaluationOfFacts: "",
      });
      setApplicationId("");
      setGrandTotal("");
    }
  };

  const handleSearch = (search) => {
    const query = search.toLowerCase();
    const result_filter_data = filterData.filter((item) => {
      const applicantName = item.application_no.toLowerCase();
      const orderPaymentNo = item.owner ? item.owner.toLowerCase() : "";
      return applicantName.includes(query) || orderPaymentNo.includes(query);
    });
    setSearchData(result_filter_data);
  };

  const handleChangeifHasOldOP = (e) => {
    setIsHaveOlderOP(e.target.checked);
    setCheckedArray([
      {
        paymentitem: "",
        fees: "",
        surcharge: "",
        penalties: "",
        AccountName: "",
        Accountcode: "",
        OfficeCode: "",
        total: "",
      },
    ]);
    setGrandTotal("");
  };

  const columns = [
    {
      title: "Application No",
      dataIndex: "application_no",
      key: "application_no",
      width: 160,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.application_no}
        </span>
      ),
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      width: 220,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.owner}
        </span>
      ),
    },

    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 130,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {new Date(record.createdAt).toLocaleDateString("en-US")}
        </span>
      ),
    },

    {
      title: "Status",
      width: 120,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.status === "1" ? (
            <Tag color="#87d068">New Application</Tag>
          ) : record.status === "2" ? (
            <Tag color="#87d068">For Recommendation</Tag>
          ) : record.status === "3" ? (
            <Tag color="#87d068">For Approval</Tag>
          ) : record.status === "4" ? (
            <Tag color="#87d068">For Payment </Tag>
          ) : record.status === "5" ? (
            <Tag color="#87d068">Paid</Tag>
          ) : record.status === "6" ? (
            <Tag color="#87d068">Release</Tag>
          ) : record.status === "15" ? (
            <Button>
              <Tag color="#f50">Denied</Tag>
            </Button>
          ) : null}
        </span>
      ),
    },

    {
      title: "",
      align: "center",
      width: 5,
      render: (text, record) => (
        <div style={{ display: "block" }}>
          <Dropdown>
            <Dropdown.Toggle
              variant="warning"
              id="dropdown-basic"
              style={{ fontWeight: "bold" }}
            >
              Action
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ margin: 0 }}>
              {record.opStatus === "0" && (
                <Dropdown.Item
                  onClick={(e) => handleForwardOpstatus(e, record)}
                >
                  Forward
                </Dropdown.Item>
              )}

              {/* <Dropdown.Item onClick={(e) => handleForwardOpstatus(e, record)}>
                Forward
              </Dropdown.Item> */}

              <Dropdown.Item
                onClick={(e) => viewLocationalClearance(e, record)}
              >
                View
              </Dropdown.Item>

              {/* {record.opStatus === "0" && record.isNoPaymenItem === true && record.status !== "6" && (
                        <Dropdown.Item onClick={(e) => handleMarkAsFinish(e, record)}>
                          Mark as Finished
                        </Dropdown.Item>
                      )} */}

              {record.status === "4" && (
                <Dropdown.Item
                  onClick={(e) => handleCheckBillingNumberIfPaid(e, record)}
                >
                  Check if Paid
                </Dropdown.Item>
              )}

              {record.status === "6" && (
                <Dropdown.Item
                  onClick={(e) => handleClearApplications(e, record)}
                >
                  Clear Application
                </Dropdown.Item>
              )}

              {record.status === "5" && (
                <Dropdown.Item
                  onClick={(e) => handleClearApplications(e, record)}
                >
                  Clear Application
                </Dropdown.Item>
              )}

              {record.opStatus === "0" && record.status !== "6" && (
                <Dropdown.Item onClick={(e) => handleUpdateShow(e, record)}>
                  Update
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>

          {record.Signature1 === "1" &&
            record.Signature2 === "1" &&
            (record.status === "5" ||  record.status === "4") && (
              <Dropdown>
                <Dropdown.Toggle
                  variant="secondary"
                  id="dropdown-basic"
                  style={{ fontWeight: "bold", marginTop: "10px" }}
                >
                  Print
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ margin: 0 }}>
                  <Dropdown.Item
                    onClick={() => handlePrintCOEForm(record.id)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Locational Clearance with COE
                  </Dropdown.Item>

                  <Dropdown.Item
                    onClick={() => handlePrintOrderOfPayment(record.id)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Order of Payment
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}

          {/* {record.Signature1 === "1" && record.Signature2 === "1" && record.status === "6" && (
                     <Dropdown>
                     <Dropdown.Toggle
                        variant="secondary"
                        id="dropdown-basic"
                        style={{ fontWeight: "bold", marginTop: "10px" }}
                     >
                        Print
                     </Dropdown.Toggle>
                    
                     <Dropdown.Menu style={{ margin: 0 }}>
                        <Dropdown.Item
                           onClick={() => handlePrintCOEForm(record.id)}
                           target="_blank"
                           rel="noreferrer"
                        >
                           Locational Clearance with COE
                        </Dropdown.Item>
                     </Dropdown.Menu>
                     </Dropdown>
              )} */}

          {record.status === "6" && (
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                style={{ fontWeight: "bold", marginTop: "10px" }}
              >
                Print
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ margin: 0 }}>
                <Dropdown.Item
                  onClick={() => handlePrintCOEForm(record.id)}
                  target="_blank"
                  rel="noreferrer"
                >
                  Locational Clearance with COE
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      ),
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Card
        hoverable
        style={{
          width: "100%",
          borderRadius: "16px",
          boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          class="form-row"
          style={{
            marginBottom: "50px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
            <div onClick={handleNewApplication}>
              <Card
                hoverable
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Statistic
                  title="New Application"
                  valueStyle={{
                    color: "#E7800F",
                  }}
                  value={newapplication.length}
                  prefix={<UserOutlined />}
                />
              </Card>
            </div>
          </div>
          <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
            <div onClick={handleDenied}>
              <Card
                hoverable
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Statistic
                  title="Denied Application"
                  valueStyle={{
                    color: "#E7800F",
                  }}
                  value={denied.length}
                  prefix={<UserOutlined />}
                />
              </Card>
            </div>
          </div>
          <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
            <div onClick={handleForRecommendation}>
              <Card
                hoverable
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Statistic
                  title="For Recommendation"
                  valueStyle={{
                    color: "#E7800F",
                  }}
                  value={recommendation.length}
                  prefix={<UserOutlined />}
                />
              </Card>
            </div>
          </div>
          <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
            <div onClick={handleApproval}>
              <Card
                hoverable
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Statistic
                  title="For Approval"
                  valueStyle={{
                    color: "#E7800F",
                  }}
                  value={approval.length}
                  prefix={<UserOutlined />}
                />
              </Card>
            </div>
          </div>
          <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
            <div onClick={handleforpayment}>
              <Card
                hoverable
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Statistic
                  title="For Payment"
                  valueStyle={{
                    color: "#E7800F",
                  }}
                  value={payment.length}
                  prefix={<UserOutlined />}
                />
              </Card>
            </div>
          </div>
          <div class="col-12 col-md-2" style={{ marginBottom: "10px" }}>
            <div onClick={handleforRelease}>
              <Card
                hoverable
                style={{
                  width: "100%",
                  borderRadius: "16px",
                  boxShadow: "0 0 16px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Statistic
                  title="For Releasing"
                  valueStyle={{
                    color: "#E7800F",
                  }}
                  value={forRelease.length}
                  prefix={<UserOutlined />}
                />
              </Card>
            </div>
          </div>
        </div>
        <Row gutter={[16, 16]} justify="center">
          <Col span={6}>
            <p style={{ textAlign: "center" }}>
              <Input
                style={{
                  width: "100%",
                  marginBottom: "20px",
                  borderRadius: "16px",
                }}
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="Search...."
              />
            </p>
          </Col>
          <Col span={14}>
            <p style={{ textAlign: "center" }}></p>
          </Col>
          <Col span={4}>
            <Button
              block
              onClick={handleshowModal}
              style={{ width: "100%", borderRadius: "16px" }}
            >
              Add
            </Button>
          </Col>
          <Col span={24}>
            <Table
              loading={searchData.length === 0 ? true : false}
              rowKey="id"
              size="middle"
              bordered
              dataSource={searchData}
              pagination={{
                pageSize: 10, // display 5 items per page
                total: searchData.length, // total number of items
              }}
              columns={columns}
            />
          </Col>
        </Row>
      </Card>

      <Modal visible={isModalVisible} closable={false} width={1000} footer={[]}>
        <Card>
          <form
            onSubmit={
              statusEvent === 1
                ? (e) => handleSubmit(e)
                : (e) => handleUpdate(e)
            }
          >
            {/* <Row gutter={[8, 8]}>
                  <Col span={12}>
                     <span>
                     <label className="loginInput-label" htmlFor="fname">
                     (ORDER OF PAYMENT)
                     </label>
                     <Select
                        className="loginInput"
                        onChange={(e) => setOccupancy(e)}
                        showSearch
                        filterOption={(input, option) =>
                           option.children.includes(input)
                        }
                        value={occupancy}
                     >
                        <Option value="1" >RESIDENTIAL (x3)</Option>
                        <Option value="2" >COMMERCIAL (x10)</Option>
                        <Option value="3" >COMMERCIAL (RENOVATION - x7.5)</Option>
                        <Option value="4" >COE FLR AREA</Option>
                        <Option value="5" >INSTITUTIONAL (x8.00)</Option>
                        <Option value="6" >SUP LOT AREA (x150.00)</Option>
                        <Option value="7" >SUP FLOOR AREA (x150.00)</Option>
                        <Option value="others">Others</Option>
                     </Select>
                     </span>
                  </Col>
               </Row> */}
            {/* <Row gutter={[8, 8]}>
              <Col span={12}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Set Multiplier:
                  </label>
                  <Input
                    value={occupancy}
                    onChange={(e) => setOccupancy(e.target.value)}
                  />
                </span>
              </Col>
            </Row> */}
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Application No
                  </label>
                  <Input
                    name="applicationNo"
                    value={values.applicationNo}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    CE No.
                  </label>
                  <Input
                    name="ceNo"
                    value={values.ceNo}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Project Activity
                  </label>
                  <Input
                    name="projectActivity"
                    value={values.projectActivity}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Owner
                  </label>
                  <Input
                    name="owner"
                    value={values.owner}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Location
                  </label>
                  <Input
                    name="address"
                    value={values.address}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Lot Area(sq.m)
                  </label>
                  <Input
                    name="lotArea"
                    type="number"
                    value={values.lotArea}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Floor Area(sq.m)
                  </label>
                  <Input
                    name="floorArea"
                    type="number"
                    value={values.floorArea}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Postal Address
                  </label>
                  <Input
                    name="postalAddress"
                    value={values.postalAddress}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Prescriptive Notation:
                  </label>
                  <TextArea
                    rows={2}
                    maxLength={5000}
                    value={values.evaluation_facts_extended}
                    name="evaluation_facts_extended"
                    onChange={handleChange}
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label className="loginInput-label" htmlFor="fname">
                    Council Resolution No.
                  </label>
                  <Input
                    name="counselResolutionNo"
                    value={values.counselResolutionNo}
                    onChange={handleChange}
                    required
                  />
                </span>
              </Col>
            </Row>
            <Row gutter={[8, 8]}>
              <Col span={24}>
                <span>
                  <label
                    className="loginInput-label"
                    htmlFor="fname"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    Council Resolution Date.
                  </label>
                  <DatePicker onChange={handleDateChange} />
                </span>
              </Col>
            </Row>

            <br></br>
            <Card>
              <Row>
                <Checkbox checked={isChecked} onChange={handleCheckboxChange}>
                  {" "}
                  Is this an application for government institution?
                </Checkbox>
              </Row>
              <Row>
                <Checkbox
                  checked={checkifhaspayitem}
                  onChange={handleChangeNoPayitem}
                >
                  {" "}
                  Is this an application for Amendment?
                </Checkbox>
              </Row>
              <Row>
                <Checkbox
                  checked={isHaveOlderOP}
                  onChange={handleChangeifHasOldOP}
                >
                  {" "}
                  Does this application have an old order of payment?
                </Checkbox>
              </Row>
            </Card>

            <br></br>

            {isHaveOlderOP && (
              <Row>
                <Col span={24}>
                  <span>
                    <label className="loginInput-label" htmlFor="fname">
                      OLD Billing Number:
                    </label>
                    <TextArea
                      rows={2}
                      maxLength={5000}
                      value={values.oldOp}
                      name="oldOp"
                      onChange={handleChange}
                      required
                    />
                  </span>
                </Col>
              </Row>
            )}

            {!isChecked && !checkifhaspayitem && !isHaveOlderOP && (
              <Card>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="table-responsive">
                      {" "}
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center"> Pay Item</th>
                            <th className="text-center"> Fees </th>
                            <th className="text-center"> Total </th>
                            <th />
                            <th />
                          </tr>
                        </thead>
                        <tbody>
                          {checkArray?.map((item, idx) => (
                            <tr id="addr0" key={idx}>
                              <td>
                                <Select
                                  style={{
                                    width: 310,
                                    marginRight: 10,
                                    marginLeft: 10,
                                    marginBottom: 20,
                                  }}
                                  placeholder="Pay Item"
                                  onChange={(e) =>
                                    handleChangeDropdown(e, idx, "paymentitem")
                                  }
                                  showSearch
                                  filterOption={(input, option) =>
                                    option.children.includes(input)
                                  }
                                  filterSort={(optionA, optionB) =>
                                    optionA.children
                                      .toLowerCase()
                                      .localeCompare(
                                        optionB.children.toLowerCase()
                                      )
                                  }
                                  value={checkArray[idx]["paymentitem"]}
                                >
                                  {listPayitem?.map((item, i) => (
                                    <Option value={item} key={item}>
                                      {item}
                                    </Option>
                                  ))}
                                </Select>
                              </td>
                              <td>
                                <Input
                                  className="form-control"
                                  onChange={(e) =>
                                    handleChangeDropdown(e, idx, "fees")
                                  }
                                  value={checkArray[idx]["fees"]}
                                />
                              </td>

                              <td>
                                <Input
                                  className="form-control"
                                  placeholder="Total"
                                  value={checkArray[idx]["total"]}
                                  readOnly
                                />
                              </td>
                              <td>
                                {checkArray.length !== 1 && (
                                  <Button
                                    onClick={() => handleRemoveArray(idx)}
                                  >
                                    <DeleteOutlined
                                      style={{
                                        marginRight: "10px",
                                        marginTop: "4px",
                                        cursor: "pointer",
                                      }}
                                    />
                                    Remove
                                  </Button>
                                )}
                              </td>
                              <td>
                                {checkArray.length - 1 === idx && (
                                  <Button
                                    onClick={handleAddArray}
                                    disabled={
                                      checkArray.length < 19 ? false : true
                                    }
                                  >
                                    <PlusOutlined
                                      style={{
                                        marginTop: "4px",
                                        cursor: "pointer",
                                      }}
                                    />
                                    Add
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="row">
                      <div className="col-lg-4"> </div>
                      <div className="col-lg-4">
                        <label className="loginInput-label" htmlFor="fname">
                          GrandTotal:
                        </label>
                        <Input
                          step="any"
                          type="number"
                          value={grandTotal}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            )}

            <br></br>
            <Row
              gutter={[24, 24]}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Col span={4}>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleCancel}
                >
                  Close
                </button>
              </Col>
              <Col span={4}>
                {statusEvent === 1 ? (
                  <span>
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </span>
                ) : statusEvent === 2 ? (
                  <span>
                    <button type="submit" className="btn btn-success">
                      Update
                    </button>
                  </span>
                ) : null}
              </Col>
            </Row>
          </form>
        </Card>
      </Modal>
      <Modal
        visible={viewData}
        width={1200}
        closable={false}
        footer={[
          <>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={handleCloseViewData} danger>
                Close
              </Button>
            </div>
          </>,
        ]}
      >
        <Row>
          <Col xs={24} xl={24}>
            <Card
              title={
                !opData?.isGovementInstitution && !opData?.isNoPaymenItem ? (
                  <Alert
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                    message={`Billing Number: ${
                      opData.order_payment_no !== "0"
                        ? opData.order_payment_no
                        : "Not Yet Approved"
                    }`}
                    type="info"
                  />
                ) : null
              }
            >
              {opData?.isGovementInstitution && (
                <Card>This application is for goverment Institution</Card>
              )}

              {opData?.isNoPaymenItem && (
                <Card>This application is for Ammendment</Card>
              )}
              <br></br>
              <Collapse size="large">
                <Panel
                  header={`Locational Details - CE No. ${opData?.ceNo}`}
                  key="1"
                >
                  <Descriptions layout="vertical" size="middle" bordered>
                    <Descriptions.Item label="Name of Applicant">
                      <b>
                        {opData && String(opData.owner).toLocaleUpperCase()}
                      </b>
                    </Descriptions.Item>
                    <Descriptions.Item label="Project Activity">
                      <b>
                        {opData &&
                          String(opData.project_activity).toUpperCase()}
                      </b>
                    </Descriptions.Item>
                    <Descriptions.Item label="Project Location">
                      <b>
                        {opData?.address
                          ? opData?.address
                          : opData &&
                            `${opData.lot_no}, ${opData.blk_no}, ${opData.location_street}, ${opData.location_barangay}, ${opData.location_district}, QUEZON CITY`}
                      </b>
                    </Descriptions.Item>
                    <Descriptions.Item label="Floor Area (sq.m)">
                      <b>{opData && String(opData.floor_area).toUpperCase()}</b>
                    </Descriptions.Item>
                    <Descriptions.Item label="Lot Area (sq.m)">
                      <b>{opData && String(opData.lot_area).toUpperCase()}</b>
                    </Descriptions.Item>
                    <Descriptions.Item label="Application No">
                      <b>
                        {opData && String(opData.application_no).toUpperCase()}
                      </b>
                    </Descriptions.Item>
                    <Descriptions.Item label="Postal Address">
                      <b>{String(opData.postalAddress)}</b>
                    </Descriptions.Item>
                    <Descriptions.Item label=" Prescriptive Notation:">
                      <b>{String(opData.evaluation_facts_extended)}</b>
                    </Descriptions.Item>
                  </Descriptions>
                </Panel>

                {!opData?.isGovementInstitution && !opData?.isNoPaymenItem && (
                  <Panel header="Order of Payment Details" key="2">
                    <Card type="inner" style={{ marginTop: "10px" }}>
                      <Row gutter={[8, 16]}>
                        <table className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th scope="col">Payitem</th>
                                <th scope="col">FEES</th>
                                <th scope="col">TOTAL</th>
                              </tr>
                            </thead>
                            <tbody>
                              {checkArray?.map((x, i) => (
                                <tr>
                                  <td>{checkArray[i]["paymentitem"]}</td>
                                  <td>{checkArray[i]["fees"]}</td>
                                  <td>{checkArray[i]["total"]}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </table>
                      </Row>
                    </Card>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        marginTop: "30px",
                      }}
                    >
                      <Row gutter={[8, 24]}>
                        <Col span={24}>
                          <span>
                            <label className="loginInput-label" htmlFor="fname">
                              GRAND TOTAL:
                            </label>
                            <Input
                              style={{
                                fontWeight: "bold",
                                fontSize: "20px",
                                width: "80%",
                                display: "flex",
                                justifyContent: "",
                              }}
                              value={`Php ${opData.grandTotal}`}
                            />
                          </span>
                        </Col>
                      </Row>
                    </div>
                  </Panel>
                )}
              </Collapse>
            </Card>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default COEForm;
